type Props = {
	size?: number
	color?: string
	strokeWidth?: number
}

/** The `−` counterpart of `PlusIcon` — same box and stroke, so the two swap without a jump. */
export const MinusIcon = ({ size = 24, color = "#0047FF", strokeWidth = 2 }: Props) => {
	return (
		<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M4.91797 11.9883H19.0497"
				stroke={color}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
